(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("calendar", [], factory);
	else if(typeof exports === 'object')
		exports["calendar"] = factory();
	else
		root["bryntum"] = root["bryntum"] || {}, root["bryntum"]["calendar"] = factory();
})(window, function() {
return 